<template>
  <div class="bottom-sheet" :data-open="state === OPEN ? 1 : 0">
    <div
      ref="card"
      class="card"
      :data-state="state"
      :style="{ top: `${ calcY }px` }"
    >
      <div class="contents" :style="{ height: `calc(100% - ${calcY}px)` }">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from '@vue/composition-api';
import eventBus from '@/eventBus';
import $ from 'jquery';

const CLOSE = 'close';
const OPEN = 'open';

export default {
  name: 'BottomSheet',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    openY: {
      type: Number,
      default: 0.15
    },
    defaultState: {
      type: String,
      default: CLOSE
    },
  },
  setup(props, { refs, emit }) {
    const state = ref(props.defaultState);

    const calcY = computed(() => {
      switch (state.value) {
        case CLOSE:
          return window.innerHeight;
        case OPEN:
          return window.innerHeight * props.openY;
        default:
          return 0;
      }
    });

    const setState = (value) => {
      if (value === OPEN) {
        emit('input', true);
      } else if (value === CLOSE) {
        emit('input', false);
      }
    };

    const watchWrapper = (e) => {
      const elem = refs.card;
      if (!elem) return;

      const { pageY } = e;
      const { top } = $(elem).offset();

      if (pageY < top && state.value === OPEN) {
        setState(CLOSE);
      }
    };

    const model = computed(() => props.value);

    watch(model, (value) => {
      if (value) {
        state.value = OPEN;
        setTimeout(() => {
          $(document.body).on('click', watchWrapper);
        }, 500);
        eventBus.$emit('body-overflow-hidden', true);
      } else {
        state.value = CLOSE;
        $(document.body).off('click', watchWrapper);
        eventBus.$emit('body-overflow-hidden', false);
      }
    });

    return {
      state,
      calcY,
      setState,
      OPEN,
      CLOSE,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

.bottom-sheet[data-open="1"] {
  position: fixed;
  top: 0;
  left: 0;
}

.bottom-sheet[data-open="0"] {
  visibility: hidden;
}

.bottom-sheet {
  z-index: 999;

  .card {
    width: 100%;
    height: 100vh;
    position: fixed;
    background: $white;
    border-radius: 10px 10px 0 0;
    box-shadow: 0 -3px 4px $iron;
    left: 0;
    z-index: 99;
  }

  .card[data-state="open"], .card[data-state="close"] {
    transition: top .3s ease-out;
  }

  .card[data-state="close"] {
    box-shadow: none;
    top: -28px;
  }

  .contents {
    max-height: 100%;
    padding-bottom: calc(100vh * 0.2);
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: visible;
  }
}
</style>
